import { navigationMenuProductsMock } from '@/shared/products'
import { routes } from '@/shared/routes'
import { HelpCircle, Home, Rss, SquareKanban, Trophy } from 'lucide-react'
import React, { ReactNode } from 'react'

export const menuMobile: {
  id: number
  icon: React.ReactNode
  label: string
  href: string
  subMenu?: {
    id: string
    icon: ReactNode
    label: string
    href: string
  }[]
}[] = [
  {
    id: 1,
    icon: <Home size={18} />,
    label: 'Início',
    href: routes.HOME,
  },
  {
    id: 6,
    icon: <SquareKanban size={18} />,
    label: 'Produtos',
    href: routes.HOME,
    subMenu: navigationMenuProductsMock.map((product) => ({
      id: product.title,
      icon: product.shortLogo,
      label: product.title,
      href: product.href,
    })),
  },
  {
    id: 2,
    icon: <Rss size={18} />,
    label: 'Blog',
    href: routes.BLOG,
  },
  {
    id: 3,
    icon: <Trophy size={18} />,
    label: 'Sobre nós',
    href: routes.ABOUT_US,
  },
  {
    id: 4,
    icon: <HelpCircle size={18} />,
    label: 'Ajuda',
    href: 'https://ajuda.treeunfe.com.br',
  },
]
